function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.387a1.129 1.129 0 100 2.258 1.129 1.129 0 000-2.258zm.31-.968h-.646a.484.484 0 01-.484-.484v-.015c0-2.836 3.123-2.565 3.123-4.33 0-.808-.716-1.622-2.316-1.622-1.175 0-1.785.389-2.388 1.157a.483.483 0 01-.655.095l-.53-.368a.483.483 0 01-.106-.693c.856-1.098 1.871-1.804 3.679-1.804 2.11 0 3.929 1.2 3.929 3.234 0 2.718-3.123 2.575-3.123 4.331v.015a.484.484 0 01-.484.484zM12 3.29c4.783 0 8.71 3.874 8.71 8.71 0 4.81-3.896 8.71-8.71 8.71A8.707 8.707 0 013.29 12 8.71 8.71 0 0112 3.29zM12 2C6.478 2 2 6.48 2 12c0 5.524 4.478 10 10 10 5.523 0 10-4.476 10-10 0-5.52-4.477-10-10-10z",
  fill: "#fff"
});
function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgHelp;